import z from "zod";

export const voucherRequestSchema = z.object({
	firstName: z.string().min(1, "Required!"),
	lastName: z.string().min(1, "Required!"),
	email: z.email("Invalid email address").min(1, "Required!"),
	dateOfBirth: z.coerce
		.date("Required!")
		.max(
			new Date(Date.now() - 568025136000),
			"You must be at least 18 years old!",
		),

	confirmAgreement: z.literal(true),
});

export type VoucherRequestSchema = z.infer<typeof voucherRequestSchema>;
export type VoucherRequestInput = z.input<typeof voucherRequestSchema>;

export type VoucherRequestResponse = {
	code: string;
};

export const passedAccreditedCertificationSchema = z.object({
	email: z.email("Invalid email address"),
	passedAt: z.coerce
		.date("Required!")
		.refine((date) => date.getTime() <= Date.now(), "Cannot be in the future"),
});

export type PassedAccreditedCertificationSchema = z.infer<
	typeof passedAccreditedCertificationSchema
>;
export type PassedAccreditedCertificationInput = z.input<
	typeof passedAccreditedCertificationSchema
>;
